import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DigitalSignCheckItem, DigitalSignCheckList} from '../../../../../digital-sign/models/digital-sign-interfaces';
import {Utilities} from '@shared/utilities/utilities.model';
import {DigitalSignCheckItemModel} from '../../../../../digital-sign/components/digital-sign-check-list/digital-sign-check-list.component';
import {MatRadioChange} from '@angular/material/radio';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-sign-options',
	templateUrl: './sign-options.component.html',
	styleUrls: ['./sign-options.component.scss']
})
export class SignOptionsComponent implements OnInit {
	privacyAccepted: number;
	digitalSignCheckList: DigitalSignCheckList;
	translateContext = TranslateContext;


	@Output() goToPaperSignEvenEmitter: EventEmitter<void> = new EventEmitter<void>();
	@Output() canGoToNextStep: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor() {

	}

	ngOnInit(): void {
		this.digitalSignCheckList = new DigitalCoreSignCheckListModel();
	}

	goToPaperSign(): void {
		this.goToPaperSignEvenEmitter.emit();
	}

	privacyRequestChange(event: MatRadioChange): void {
		this.privacyAccepted = event.value;
		if (!this.privacyAccepted && !Utilities.isVoid(this.digitalSignCheckList) && !Utilities.isVoid(this.digitalSignCheckList.checklist)) {
			this.digitalSignCheckList.checklist.forEach(
				item => {
					item.value = false;
				});
		}
	}

	isAllChecked(): void {
		this.canGoToNextStep.emit(this.digitalSignCheckList.isAllChecked());
	}
}

export class DigitalCoreSignCheckListModel extends DigitalSignCheckList {
	reference_type: number;
	checklist: DigitalSignCheckItem[];
	translateContext = TranslateContext;

	constructor() {
		super();
		this.reference_type = 1;
		this.checklist = [];
		this.checklist.push(new DigitalSignCheckItemModel(true, 1));
		this.checklist.push(new DigitalSignCheckItemModel(true, 2));
	}
}
